import React from 'react';
import HeroSection from '../components/HeroSection';
import AirlineStrip from '../components/AirlineStrip';
import FlashDeals from '../components/FlashDeals';
import PopularRoutes from '../components/PopularRoutes';
import WhyChooseUs from '../components/WhyChooseUs';
import Testimonials from '../components/Testimonials';
import CtaBanner from '../components/CtaBanner';
import SEO from '../components/SEO';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'FlightBooKaro',
  url: 'https://flightbookkaro.com',
  description: 'Fly More. Spend Less. Compare 100+ airlines and book the cheapest flight in 60 seconds.',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://flightbookkaro.com/flights?origin={origin}&destination={destination}&date={date}&adults=1',
    'query-input': 'required name=origin required name=destination required name=date',
  },
};

export default function HomePage() {
  return (
    <div>
      <SEO
        canonical="/"
        description="Fly More. Spend Less. Compare fares across 100+ airlines and book the cheapest flight in 60 seconds — no hidden fees, instant e-ticket."
        keywords="cheap flights India, book flights online, flight deals, lowest airfare, domestic flights India, compare airlines, best flight fares, FlightBooKaro"
        jsonLd={homeJsonLd}
      />
      <HeroSection />
      <AirlineStrip />
      <FlashDeals />
      <PopularRoutes />
      <WhyChooseUs />
      <Testimonials />
      <CtaBanner />
    </div>
  );
}
